export const resources = {
  categoriesTitle: 'Categories',
  subcategoriesTitle: 'Formats',
};
